// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sendXHR, failedRequest } from "src/lib/utils";
import { MySchedule } from "./my-schedule.jsx";
import { UniversityEvents } from "./university-events.jsx";

// Stateful components

export class Schedule extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {

        super(props);

        this.state = {
            "active_tab": "schedule",
            "event_data": {}
        };

        // Binds
        this.getEventsData = this.getEventsData.bind(this);
        this.processEventsData = this.processEventsData.bind(this);
        this.tabClick = this.tabClick.bind(this);
        this.handleTimetableClick = this.handleTimetableClick.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        this_component.getEventsData();
    }

    // Get all portal pages
    getEventsData() {
        var this_component = this;
        var endpoints_container = document.querySelector('#endpoints');
        var events_url = endpoints_container.getAttribute('data-events');

        var xhr_parameters = {
            'request_url': events_url,
            'request_success': this_component.processEventsData,
            'request_failure': failedRequest,
            'request_extras': ""
        };

        sendXHR(xhr_parameters, 'GET');
    }

    // Save all portal pages and indicate the portal has finished loading
    processEventsData(response) {
        var this_component = this;
        var all_events = JSON.parse(response);
        
        this_component.setState({
            "event_data": all_events
        });
    }

    //
    // Functions
    //
    tabClick(e) {
        e.preventDefault();
        var this_component = this;
        var target = e.currentTarget;
        var current_active_tab = this_component['state']['active_tab'];
        var clicked_tab = target.dataset.tab;
        
        if(clicked_tab != current_active_tab){
            this_component.setState({
                "active_tab": clicked_tab
            });
            // Loose focus after changing active tab
            document.activeElement.blur();
        }
    }

    handleTimetableClick(event){
        var this_component = this;
        var has_course_code = this_component['state']['course_code'];
        if(!has_course_code){
            event.preventDefault();
            alert('You have no current enrolment schedule');
            return false;
        }
        return;
    }
    


    //
    // Render
    //

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var active_tab = this_component['state']['active_tab'];
        var events_data = this_component['state']['event_data'];

        var schedule_is_active = false;
        var schedule_is_active_classname = false;
        var events_is_active = false;
        var events_is_active_classname = false;

        if(active_tab == 'schedule'){
            schedule_is_active = true;
            schedule_is_active_classname = 'active';
        } else {
            events_is_active = true;
            events_is_active_classname = 'active';
        }

        return (
            <div className="schedule__wrapper" data-ga-label="Schedule">
            
                <div className="schedule__tabs">
                    <a href="#" data-tab="schedule" className={'schedule__tab ' + schedule_is_active_classname} onClick={this_component.tabClick}>My Schedule</a>
                    <a href="#" data-tab="events" className={'schedule__tab ' + events_is_active_classname} onClick={this_component.tabClick}>University Events</a>
                </div>

                {schedule_is_active ? (
                    <MySchedule date={portal_context.selected_date} />
                ) : (
                    <UniversityEvents date={portal_context.selected_date} data={events_data} />
                )}

            </div>
        );
    }

};

Schedule.contextType = PortalContext;
